import { createStore } from './store'

export interface Toast {
  id: number
  message: string
  tone: 'neutral' | 'error'
  action?: { label: string; run: () => void }
}

export const toasts = createStore<Toast | null>(null)

let nextId = 1
let timer: ReturnType<typeof setTimeout> | undefined

/** One message at a time, replacing the last. A pipeline app does not need a queue. */
export function toast(message: string, options: Partial<Omit<Toast, 'id' | 'message'>> = {}): void {
  clearTimeout(timer)
  const id = nextId++
  toasts.set({ id, message, tone: options.tone ?? 'neutral', action: options.action })
  timer = setTimeout(() => dismissToast(id), options.action ? 5000 : 2600)
}

export function dismissToast(id?: number): void {
  if (id === undefined || toasts.get()?.id === id) toasts.set(null)
}

export function toastError(error: unknown, fallback = 'Something went wrong'): void {
  const message = error instanceof Error && error.message ? error.message : fallback
  toast(message, { tone: 'error' })
}
